import React, { useEffect } from 'react';
import pipes from '../assets/Pipes.jpg';
import './Home.css';
import { Link } from 'react-router-dom';
import { loadChatWidget } from '../utils/chatWidget';

function Home() {
  useEffect(() => {
    loadChatWidget();
  }, []);

  return (
    <div className="home-discovery">
      <section className="home-discovery__hero" aria-label="BagpipeBlasphemy">
        <div
          className="home-discovery__hero-media"
          style={{ backgroundImage: `url(${pipes})` }}
          role="img"
          aria-label="Highland pipes"
        />
        <div className="home-discovery__hero-shade" aria-hidden="true" />
        <div className="home-discovery__hero-inner">
          <h1 className="home-discovery__brand">BagpipeBlasphemy</h1>
          <p className="home-discovery__headline">
            Master the Highland Bagpipes — Faster, Smarter, and More Enjoyably
          </p>
          <p className="home-discovery__subhead">
            Transform your practice with accurate, real-time feedback games designed specifically
            for the Great Highland Bagpipe. Whether you&apos;re just starting out or refining your
            technique, BagpipeBlasphemy helps you build consistent daily habits that actually stick.
          </p>
          <p className="home-discovery__support">
            Optimized for digital/electronic practice chanters with clean line-in or USB input.
            Acoustic chanters work too after a quick calibration — no more struggling with room
            mics.
          </p>
          <div className="home-discovery__ctas">
            <Link className="home-discovery__btn home-discovery__btn--primary" to="/chantersync">
              Get started
            </Link>
            <a className="home-discovery__btn home-discovery__btn--secondary" href="/learn/index.html">
              Learn more
            </a>
            <Link className="home-discovery__btn home-discovery__btn--secondary" to="/auth">
              Sign up
            </Link>
          </div>
        </div>
      </section>

      <section className="home-discovery__loop">
        <h2>How it works</h2>
        <ol>
          <li>
            <Link to="/chantersync">Manage Chanters</Link> — add a chanter profile and save
            frequencies.
          </li>
          <li>
            <Link to="/chanter-test">Chanter Test</Link> — verify the profile and microphone once.
          </li>
          <li>
            <Link to="/blaster">Note Blaster</Link> /{' '}
            <Link to="/note-battle">Note Battle</Link> — practice with pitch that matches your
            instrument.
          </li>
        </ol>
      </section>

      <footer className="home-discovery__footer">
        <p>
          The perfect practice tool between lessons — not a replacement for a great teacher.
        </p>
        <p className="home-discovery__footer-meta">
          <a href="/">Home</a>
          {' · '}
          <a href="/faq/">FAQ</a>
          {' · '}
          <a href="/resources">Resources</a>
          {' · '}
          <a href="/learn/index.html">Articles</a>
          {' · '}
          <a href="/about-us">About</a>
          {' · '}
          <a href="/contact">Contact</a>
          {' · '}
          <a href="/faq/privacy.html">Privacy Policy</a>
        </p>
      </footer>
    </div>
  );
}

export default Home;
